module.exports = __webpack_public_path__ + "static/media/white-arrow-down.d1e2d29d.svg";